import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserApi } from '../../services/api/user';
import { tokenStorage } from '../../services/auth/tokenStorage';
import { logIn } from '../../store/loggedIn';
import apiClient from '../../services/api/apiClient';

export const OAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const error = searchParams.get('error');

    if (error) {
      console.error('OAuth error:', error);
      navigate('/', { replace: true });
      return;
    }

    const accessToken = searchParams.get('accessToken');

    if (!accessToken) {
      navigate('/', { replace: true });
      return;
    }

    tokenStorage.setAccessToken(accessToken);

    window.history.replaceState({}, '', '/oauth/callback');

    const pendingDesktop = sessionStorage.getItem('desktopAuthSession');

    if (pendingDesktop) {
      sessionStorage.removeItem('desktopAuthSession');

      let desktopSession: { sessionId?: string; state?: string } | null = null;
      try {
        desktopSession = JSON.parse(pendingDesktop);
      } catch {
        desktopSession = null;
      }

      if (desktopSession?.sessionId && desktopSession?.state) {
        apiClient
          .post('/v1/auth/desktop/oauth', {
            sessionId: desktopSession.sessionId,
            state: desktopSession.state,
            accessToken,
          })
          .then((response) => {
            const redirectUrl = response.data.redirectUrl;

            if (!redirectUrl || !redirectUrl.startsWith('codecareer://')) {
              console.error('Desktop OAuth callback failed: invalid redirectUrl', redirectUrl);
              navigate('/', { replace: true });
              return;
            }

            window.location.href = redirectUrl;
          })
          .catch((err) => {
            console.error('Desktop OAuth callback failed:', err);
            navigate('/', { replace: true });
          });
        return;
      }
    }

    UserApi.me()
      .then(async () => {
        dispatch(logIn());

        let sources: string[] = [];
        try {
          sources = await UserApi.getOnboardingSource();
        } catch {
          sources = [];
        }

        navigate(sources.length > 0 ? "/app" : "/onboarding", { replace: true });
      })
      .catch(() => {
        tokenStorage.clear();
        navigate('/', { replace: true });
      });
  }, [dispatch, navigate, searchParams]);

  return null;
};
